
<template>
  <BreadCrumb PageTitle="Reseller" />
  <div class="row" v-if="user">
    <div class="col-xxl-12">
      <ResellerContent />
    </div>
  </div>
</template>

<script setup>
// import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ResellerContent from "../../components/Admin/Customer/ResellerContent.vue";

import { useAccountStore } from "@/stores"
import { storeToRefs } from 'pinia';
const accountStore = useAccountStore();
const { user } = storeToRefs(accountStore);
</script>